module.exports = __webpack_public_path__ + "img/logo1mix-1.0c45f42c.jpg";